// package imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// project imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const ContestInitialization = lazy(
  () => import('pages/contest/contestInitialization/contestInitialization')
);
const ContestInitializationRoute = (
  <Route
    path={routeName.contestInitialization}
    element={
      <PrivateRoute name={PrivateRouteConst.RUN_CONTEST}>
        <Suspense
          fallback={
            <div>
              <Loading />
            </div>
          }
        >
          <ContestInitialization />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default ContestInitializationRoute;
